<template>
  <div class="aboutus">
    <div class="row">
      <div class="col-md-12 banner">
        <img class="banner-img" src="@static/img/aboutus/banner.png" height="627px" width="100%" alt="">
        <span class="banner-title" v-text="$t('home_page.name')"></span>
        <span class="banner-slogan" v-text="$t('home_page.slogan')"></span>
      </div>
    </div> 
    <div class="row">
      <div class="col-md-12">
        <div class="us-info">
          <div>
            <div class="item">
              <div class="icon">
                <img src="@static/img/aboutus/loop.png" alt="">
              </div>
              <div class="title" v-text="$t('about_us.imgLine[0].title')"></div>
              <div class="desc" v-text="$t('about_us.imgLine[0].desc')"></div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="@static/img/aboutus/earth.png" alt="">
              </div>
              <div class="title" v-text="$t('about_us.imgLine[1].title')"></div>
              <div class="desc" v-text="$t('about_us.imgLine[1].desc')"></div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="@static/img/aboutus/guy.png" alt="">
              </div>
              <div class="title" v-text="$t('about_us.imgLine[2].title')"></div>
              <div class="desc" v-text="$t('about_us.imgLine[2].desc')"></div>
            </div>
          </div>
          <div>
            <div class="title"><span v-text="$t('about_us.title')"></span></div>
            <div style="padding: 60px 30px 30px;text-align: left;line-height: 40px;">
              <div style="border-bottom: 1px solid #999;">
                <span style="display: inline-block; width: 220px;" v-text="$t('about_us.name_title')"></span>
                <span v-text="$t('about_us.name_desc')"></span>
              </div>
              <div style="border-bottom: 1px solid #999;">
                <span style="display: inline-block; width: 220px;" v-text="$t('about_us.time_title')"></span>
                <span v-text="$t('about_us.time_desc')"></span>
              </div>
              <div style="border-bottom: 1px solid #999;">
                <span style="display: inline-block; width: 220px;" v-text="$t('about_us.addr_title')"></span>
                <span v-text="$t('about_us.addr_desc')"></span>
              </div>
              <div style="border-bottom: 1px solid #999;">
                <span style="display: inline-block; width: 220px;" v-text="$t('about_us.money_title')"></span>
                <span v-text="$t('about_us.money_desc')"></span>
              </div>
              <div style="border-bottom: 1px solid #999;">
                <span style="display: inline-block; width: 220px;" v-text="$t('about_us.scope_title')"></span>
                <span v-text="$t('about_us.scope_desc')"></span>
              </div>
            </div>
            <div class="us-img">
              <img src="@static/img/aboutus/us.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ">
        <div class="banner3">
          <span class="title" v-text="$t('about_us.banner3Title')"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Aboutus',
  data () {
    return {
      msg: 'aboutus'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.banner {
  position: relative;
}
.banner-title {
  position: absolute;
  left: 0;
  top: 240px;
  font-size: 80px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  width: 100%;
}
.banner-slogan {
  position: absolute;
  left: 0;
  top: 360px;
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Aboutus.vue